export default "__VITE_ASSET__iVF227jr__"